import React, { useEffect } from "react";
import SingleBill from "../../web-redemption/SingleBill";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { useNavigate } from "react-router-dom";
import { MenuIcon, Title, Header } from "./Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import styled from "@emotion/styled";

const StyledCheckout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  .css-mdfac0 {
    border-radius: 9999px;
    background: rgba(44, 44, 44, 0.6);
    width: 48px;
    height: 48px;
    flex-shrink: 0;
  }
  .css-pi2nr4 {
    margin-bottom: 16px;
  }
  .css-f9clb4 {
    display: none;
  }
  &:has(.success__header) {
    height: 100vh;
    justify-content: flex-start;
    .css-pi2nr4 {
      display: none;
      justify-content: center;
    }
    .css-f9clb4 {
      display: block;
      justify-content: flex-start;
      margin-bottom: 200px;
      display: flex;
      gap: 20px;
    }
  }
  &:has(.receipt__header) {
    .css-pi2nr4 {
      display: none;
    }
  }
`;

const BackToHomeContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  font-family: var(--rethink-sans-bold, "Rethink-Sans-Bold", "sans-serif");
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 27px;
  background: var(--background-color);
  width: 100%;
  padding: 2rem;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 20px;
  padding: 0;
`;

const HomeText = styled.span`
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: #fff;
`;

const Checkout = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const diner = useSelector((state: RootState) => state.checkout.dinerProfile);
  const notes = useSelector((state: RootState) => state.checkout.notes);
  const location = useSelector(
    (state: RootState) => state.checkout.selectedLocation,
  );
  const ticketData = useSelector(
    (state: RootState) => state.checkout.ticketData,
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
    if (!ticketData || !diner || !location) {
      navigate("/location-selection");
    }
  }, [ticketData, user, diner, location]);
  return (
    <StyledCheckout>
      <Header>
        <MenuIcon onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} color="#fff" />
        </MenuIcon>
        <Title>inKind Manager</Title>
      </Header>
      <BackToHomeContainer>
        <BackButton onClick={() => navigate("/")}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </BackButton>
        <HomeText>Home</HomeText>
      </BackToHomeContainer>
      <SingleBill
        projectInit={{
          project_slug: location?.project?.slug ?? "",
          project_id: location?.project_id ?? 0,
          location_id: location?.id ?? 0,
          credit_balance: diner?.credit_balance ?? 0,
          ik_pass_balance: diner?.ik_pass_balance ?? 0,
          stripe_public_key: location?.project?.stripe_public_key ?? "",
          credit_cards: diner?.stripe_sources ?? [],
          offers: diner?.active_offers ?? [],
          sub_credit_back_percent: diner?.sub_credit_back_percent ?? 0.2,
          logo_path: location?.project?.logo_path ?? "",
        }}
        locationInit={[
          {
            location_id: location?.id ?? 0,
            name: location?.name ?? "",
            location: {
              address: location?.address ?? "",
              city: location?.city ?? "",
              state: location?.state ?? "",
              zip_code: location?.zip_code ?? "",
            },
            timezone: location?.timezone,
            custom_tip_percent0: location?.custom_tip_percent0 ?? 0,
            custom_tip_percent1: location?.custom_tip_percent1 ?? 0,
            custom_tip_percent2: location?.custom_tip_percent2 ?? 0,
            custom_tip_percent3: location?.custom_tip_percent3 ?? 0,
            checkout: {
              tipping_enabled: true,
            },
          },
        ]}
        ticketInit={ticketData ?? undefined}
        ticket={""}
        locationsCount={0}
        requiresAuthentication={true}
        userToken={user?.token}
        posSlug={""}
        location={""}
        isFromManagersWebApp={true}
        userId={diner?.id}
        notes={notes}
      />
    </StyledCheckout>
  );
};

export default Checkout;
